import { api } from "../lib/axios/config";

export type TipoPesquisa = "CONFORMIDADE_VENDA" | "POS_ATENDIMENTO" | "CANCELAMENTO" | "NPS";

export type TipoPergunta = "ESCALA_1_5" | "ESCALA_0_10" | "SIM_NAO" | "TEXTO_LIVRE" | "MULTIPLA_ESCOLHA";

export type TipoEventoPesquisa = "EXIBIDA" | "INICIADA" | "PULADA" | "CONCLUIDA";

export type CondicaoExibicao = {
  chave: string;
  valor: string;
};

export type Pergunta = {
  chave: string;
  texto: string;
  tipo: TipoPergunta;
  obrigatoria: boolean;
  opcoes?: string[];
  exibirSe?: CondicaoExibicao | null;
};

export type Questionario = {
  titulo: string;
  descricao?: string;
  perguntas: Pergunta[];
};

export type DefinicaoPesquisa = {
  id: string;
  tipo: TipoPesquisa;
  versao: number;
  questionario: Questionario;
};

export type ItemResposta = {
  chave: string;
  valorNumerico?: number | null;
  valorTexto?: string | null;
  valorBooleano?: boolean | null;
};

export type RegistrarRespostaPayload = {
  tipo: TipoPesquisa;
  itens: ItemResposta[];
};

export type RegistrarRespostaResponse = {
  respostaId: string;
  jaRespondida: boolean;
};

export async function getDefinicaoPesquisa(tipo: TipoPesquisa): Promise<DefinicaoPesquisa> {
  const response = await api.get<DefinicaoPesquisa>(`pesquisas/definicao?tipo=${tipo}`);
  return response.data;
}

export async function registrarRespostaPesquisa(payload: RegistrarRespostaPayload) {
  const response = await api.post<RegistrarRespostaResponse>("pesquisas/respostas", payload);
  return response.data;
}

export type ConvitePesquisa = {
  tipo: TipoPesquisa;
  versao: number;
  questionario: Questionario;
};

export async function getPesquisaPorConvite(token: string): Promise<ConvitePesquisa> {
  const response = await api.get<ConvitePesquisa>(`pesquisas/convites/${token}`);
  return response.data;
}

export async function registrarRespostaPorConvite(token: string, itens: ItemResposta[]) {
  const response = await api.post<RegistrarRespostaResponse>(`pesquisas/convites/${token}/respostas`, { itens });
  return response.data;
}

export async function registrarEventoPesquisa(tipo: TipoPesquisa, evento: TipoEventoPesquisa) {
  try {
    await api.post("pesquisas/respostas/eventos", { tipo, evento });
  } catch {
    // Telemetria nao pode interromper o cadastro.
  }
}
